import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CommonAlertModalComponent } from "./common-alert-modal.component";
import { TranslateModule } from "@ngx-translate/core";
import { PlaceholderReplacePipe } from "src/app/shared/pipes/placeholder-replace/placeholder-replace.pipe";
import { FormsModule } from "@angular/forms";

@NgModule({
  imports: [CommonModule, TranslateModule, PlaceholderReplacePipe, FormsModule, CommonAlertModalComponent],
  exports: [CommonAlertModalComponent],
})
export class CommonAlertModalModule {}
